module.exports = __webpack_public_path__ + "static/media/logo.dc260c99.svg";